import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
const FormItem = Form.Item;

moment.locale();

class FormDenunciasAnteriores extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {
          ...values,
          valor,
        };

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    // console.log("Entre a evaluar el puntaje con....");
    // console.log(respuestas);

    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.

    if (respuestas.denunciaPenalReciente) {
      valor = valor + 3;
    }

    if (respuestas.denunciaCivilReciente) {
      valor = valor + 1;
    }

    if (respuestas.intervencionPolicialReciente) {
      valor = valor + 3;
    }

    // console.log("El resultado es.... ", valor);

    return valor;
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Evaluación de Denuncias Anteriores</h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          {' '}
          <FormItem
            {...formItemLayout}
            label="Denuncia penal reciente (3 meses)"
          >
            {getFieldDecorator('denunciaPenalReciente', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Denuncia civil reciente (3 meses)"
          >
            {getFieldDecorator('denunciaCivilReciente', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Intervencion policial reciente">
            {getFieldDecorator('intervencionPolicialReciente', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormDenunciasAnteriores);
